<template>
  <div id="login"  :style="{transformOrigin: 'top left',height: '100vh',width: '100vw'}" >
    <div class="loginConbox">
      <!-- <div class="logo">
        VISUAL COMFORT &CO.
      </div> -->
      <div class="login-content" :style="scaleStyle">
        <!--<div class="logo-left">
          <div class="login-logo">
            <img src="../../assets/images/login-logo.png">
          </div>
          <div class="logo-content">
            <p class="top">专业成就无限可能</p>
            <p class="bottom">UNLIMITED POSSIBILITIES FOR PROFESSIONAL
            ACHIEVEMENTS</p> 
          </div>
        </div>-->
        <div class="right-content">
          <!--<div class="logo">
             <img src="../../assets/images/logo.jpeg">
          </div>-->
          <div class="title">
          </div>
          <el-form
              :model="loginForm"
              status-icon
              label-width="0"
              class="demo-ruleForm"
            >
              <!-- <el-form-item>
                <el-input
                  type="text"
                  v-if="companyName"
                  v-model="loginForm.aspName"
                  auto-complete="off"
                  placeholder="请输入公司名称"
                  clearable
                >
                <img slot="prefix"  src="../../assets/images/company.png">
                </el-input>
              </el-form-item> -->
              <el-form-item>
                <el-input
                  type="text"
                  v-model="loginForm.username"
                  auto-complete="off"
                  placeholder="请输入登录账号"
                  clearable
                >
                  <img slot="prefix"  src="../../assets/images/username.png">
                </el-input>
              </el-form-item>
              <el-form-item>
                <el-input
                  type="password"
                  v-model="loginForm.password"
                  ref="pwd"
                  @keyup.enter.native="submitForm"
                  auto-complete="off"
                  placeholder="请输入登录密码"
                  show-password
                >
                  <img slot="prefix"  src="../../assets/images/password.png">
                </el-input>
              </el-form-item>
              <!-- <div style="font-size: 12px;color: #565e66;padding-left: 167px;">
                没有账号？请从这里 <a  @click="register">注册</a>
              </div> -->
               
                <el-button
                style="margin-top: 10px;width: calc(20px + 100%);margin-left: -20px;"
                class="login-subBtn"
                type="primary"
                @click="submitForm"
                >登录
                </el-button>
            <el-form-item class="operation" style="margin-top: 6px;">
              <el-checkbox v-model="checked">记住密码</el-checkbox>
              <router-link :to="{path:'/forgetPassword'}">忘记密码？</router-link>
              <!-- <a href="javascript:;" @click="find()">忘记密码？</a> -->
            </el-form-item>
            </el-form>
        </div>
      </div>
      
      <!-- <div class="header">
      </div>
      <div class="loginBox">
        <div class="loginCon">
          <el-card shadow="always" v-if="smdl" style="width: 460px">
            <div class="logo">
              <img src="./logo01.png" />
            </div>
            <el-form
              :model="loginForm"
              status-icon
              label-width="100px"
              class="demo-ruleForm"
            >
              <el-form-item>
                <el-input
                  type="text"
                  v-if="companyName"
                  v-model="loginForm.aspName"
                  auto-complete="off"
                  placeholder="请输入公司名称"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-input
                  type="text"
                  v-model="loginForm.username"
                  auto-complete="off"
                  placeholder="请输入登录账号"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-input
                  type="password"
                  v-model="loginForm.password"
                  ref="pwd"
                  @keyup.enter.native="submitForm"
                  auto-complete="off"
                  placeholder="请输入登录密码"
                  show-password
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button
                  class="login-subBtn"
                  type="primary"
                  @click="submitForm"
                  >登录</el-button
                >
              </el-form-item>
            </el-form>
          </el-card>

          <el-card shadow="always" class="login-module" v-else>
            <div slot="header" class="clearfix formTitlt">
              <span>扫码登录</span>
              <span class="titIconbox">
                <i class="iconfont xu-mimadenglu1 fa-lg iconcolor"></i>
                <i
                  class="iconfont xu-imagevector el-icon--right fa-lg pointer"
                  @click="smdl = !smdl"
                ></i>
              </span>
            </div>
            <div class="ewmbox">
              <div class="ewm">
                <img
                  src="https://img.alicdn.com/tfscom/TB1ivYYyHvpK1RjSZFqwu3XUVXa.png"
                />
              </div>
              <div class="ewmicon">
                <i class="iconfont xu-saomadenglu fa-2x iconcolor"></i>
                <p>打开 微信 扫一扫登录</p>
              </div>
              <p class="smalltxt">
                <router-link class="a" to="#">免费注册</router-link>
              </p>
            </div>
          </el-card>
        </div>
      </div> -->
    </div>
    <!-- <div class="footCss"></div> -->
    <div class="login-footer">
      <a style='color: #fff;text-decoration:none' href='https://beian.miit.gov.cn/'>Copyright ©2019湖南汉森制药股份有限公司 湘ICP备14000676号</a>
    </div>
  </div>
</template>
<script>
import { getQueryString } from "@/assets/common/common";
import { encryptDes,decryptDes } from "@/utils/des";
import Cookies from "js-cookie";
export default {
  data() {
    return {
      smdl: true,
      checked: true,
      loginForm: {
        username: "",
        password: "",
        systemId: 1,
        aspName: '湖南汉森制药股份有限公司'
      },
      options: [],
      companyName: false,
      scaleStyle: {
				transform: 'scale(1)',
			},
    };
  },
  methods: {
    isInWeCom() {
      const ua = navigator.userAgent.toLowerCase();
      // 企业微信包含 wxwork 标识
      return ua.indexOf('wxwork') > -1;
    },
    isIOSSafari() {
      const ua = navigator.userAgent || '';
      const isiOS = /iP(hone|od|ad)/i.test(ua);
      // 只对 iOS Safari 生效：排除 Chrome/Firefox 等内核浏览器
      const isSafari = /Safari/i.test(ua) && !/CriOS/i.test(ua) && !/FxiOS/i.test(ua);
      return isiOS && isSafari;
    },
    // 去除路径 # 号及其后面的所有内容
    prepareUrlForSignature(fullUrl) {
      return fullUrl.split('#')[0];
    },
    openPortal () {
      let localUrl = ''
      localUrl = window.location.href
      console.log('getSystemInfo', localUrl)
      this.$axios.post(this.global.BASE_URL + '/dmz/qywx/info/conf/jsapi/sign',
        {
          data: {
            wechatCode: 'oa',
            url: this.prepareUrlForSignature(localUrl),
          },
          asp: this.global.asp,
        },
      ).then(res => {
        if (res.data.code === '0000') {
          console.log(res.data.data,'res.data.data')
            ww.register({
              corpId: res.data.data.appId,
              agentId:res.data.data.agentId,
              getConfigSignature:()=>{
                return {
                  timestamp: res.data.data.timestamp, 
                  nonceStr: res.data.data.nonceStr, // 必填，生成签名的随机串
                  signature: res.data.data.signature
                } 
              },
              getAgentConfigSignature:()=>{
                return {
                  timestamp: res.data.data.timestamp, 
                  nonceStr: res.data.data.nonceStr, // 必填，生成签名的随机串
                  signature: res.data.data.signature2
                } 
              }
            , // 必填，签名
            jsApiList: [
              'openDefaultBrowser',	
            ],
            debug: true
            })
            const doOpen = () => {
              ww.openDefaultBrowser({
                url: `${this.global.BASE_URL}/#/login`,
                success: function (res) {
                  console.log('打开默认浏览器成功');
                  window.close()
                }
              })
            }

            // iOS Safari 会拦截“非用户触发”的自动跳转；仅 iOS Safari 弹窗确认
            if (this.isIOSSafari()) {
              this.$confirm('iOS 可能会拦截自动跳转，点击“确认”后将打开默认浏览器继续。', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning',
                center: true
              })
                .then(() => {
                  doOpen()
                })
                .catch(() => {})
            } else {
              doOpen()
            }
          console.log('------------------------------------')
        }
      })	
    },
     //用户注册
     register(){
      console.log('用户注册')
      this.$router.push({path:'/register'})
    },
    // 获取安装费用折扣
    // getInstallValue() {
    //   const url = `${this.global.MSI_MIS}/install/getInstallValue`;
    //   this.$axios.post(url, { data: {} }).then((res) => {
    //     if (res.data.code === "0000") {
    //       const data = res.data.data ? res.data.data / 10 : 1;
    //       this.$store.dispatch("setInstallValue", data);
    //     }
    //   });
    // },
    setCookies(name,pwd,aspName){
      Cookies.set('name', name, { expires: 365 })
      Cookies.set('pwd', pwd, { expires: 365 })
      Cookies.set('aspName', aspName, { expires: 365 })
    },
    submitForm() {
      // 账号密码非空校验
      if (this.loginForm.username === "" || this.loginForm.password === "") {
        this.$message({
          showClose: true,
          message: "账号或密码不能为空",
          type: "error",
        });
        return false;
      }
      // if (this.companyName && !this.loginForm.aspName) {
      //   this.$message("公司名称不能为空");
      //   return false;
      // }
      // 调用方法登录后台
      this.$axios({
        method: "post",
        url: this.global.BASE_DMZ + "/staff/login", // 这里是发送给后台的数据'/base/acl/staff/login'
        data: this.qs.stringify({
          loginName: this.loginForm.username,
          password: encryptDes(this.loginForm.password),
          systemId: this.loginForm.systemId,
          aspName: '湖南汉森制药股份有限公司',
        }),
      })
        .then((response) => {
          // 这里使用了ES6的语法
          if (response.data.status === "N") {
            this.$message({
              showClose: true,
              message: response.data.message,
              type: "error",
            });
          } else {
            if (response.data.data.outType === 35) {
              this.$message({
                showClose: true,
                message: '您需要修改用户密码',
                type: 'error'
              })
              this.$router.push({name: 'modifyPassword',
                params: {
                  // 之前有公司名要填写，现在没有了，所以aspName默认湖南汉森制药股份有限公司
                  // this.loginForm.aspName
                  aspName: response.data.data.aspName,
                  loginName: this.loginForm.username
                }})
              console.log('dddd')
            }else{
              if(this.checked){
              this.setCookies(encryptDes(this.loginForm.username), encryptDes(this.loginForm.password), encryptDes(this.loginForm.aspName))
            } else {
              Cookies.remove('name')
              Cookies.remove('pwd')
              Cookies.remove('aspName')
            }
            this.$store
              .dispatch("setToken", response.data.data.certificate)
              .then(() => {
                localStorage.setItem(
                  "user",
                  JSON.stringify(response.data.data)
                );
                // this.$store.dispatch('getInfo', this.$store.getters.token)
                // this.$store.dispatch("newRoutes");
                localStorage.setItem('isMenu', true)
                this.$router.push({ path: "/main"})
                // let mobileLoginUrl = getQueryString("mobileLoginUrl");
                // if (mobileLoginUrl) {
                //   this.$router.push({ name: mobileLoginUrl});
                // } else {
                //   this.getInstallValue();
                //   this.$router.push({ path: "/"});
                // }
              });
            }
          }
        })
        .catch((error) => {
          console.log(error); // 请求失败返回的数据
        });
    },
    //    else {
    // 	    let that = this
    //     // 将 username 设置为 token 存储在 store，仅为测试效果，实际存储 token 以后台返回为准
    //     that.$store.dispatch('setToken', that.loginForm.username).then(() => {
    // 	  that.$router.push({path: '/'})
    // 	  sessionStorage.setItem('user', that.loginForm.username);
    //     }).catch(res => {
    //       that.$message({
    //         showClose: true,
    //         message: res,
    //         type: 'error'
    //       })
    //     })
    //   }
    message() {
      const h = this.$createElement;
      this.$notify({
        title: "警告",
        message: h("i", { style: "color: teal" }, ""),
        duration: 6000,
      });
    },
    updateScale() {
			const designWidth = 380;
			const designHeight = 260; // 设计稿基准高度
			const windowWidth = window.innerWidth;
			const windowHeight = window.innerHeight;

			// 动态调整容器高度（避免留白）
      const containerWidth = 380 / 1920 * windowWidth
			const containerHeight = 260 / 1030 * windowHeight;

      const scale = containerWidth / 330

      console.log(containerWidth,'scale',containerHeight)

			this.scaleStyle = {
        transformOrigin: 'top left',
				transform: `scale(${scale})`,
			}
		},
  },
  created() {
    console.log(787878)
    console.log(Cookies.get('name'))
    console.log(decryptDes(Cookies.get('pwd')))
    console.log(Cookies.get('aspName'))
    if(Cookies.get('name') && Cookies.get('pwd') && Cookies.get('aspName')){
      this.$set(this.loginForm,'username',decryptDes(Cookies.get('name')))
      this.$set(this.loginForm,'password',decryptDes(Cookies.get('pwd')))
      this.$set(this.loginForm,'aspName',decryptDes(Cookies.get('aspName')))
    }
    let url = window.location.href;
    if (url.indexOf("47.115.12.30") === -1) {
      this.companyName = true;
    }
    if(this.isInWeCom()){
      console.log('判断是否在企微')
      this.openPortal()
    }
  },
  mounted() {
		this.updateScale();
		window.addEventListener('resize', this.updateScale);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.updateScale);
	},
};
</script>
<style lang="scss">

#login {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  // background: url(../../assets/images/grey-background.jpg) no-repeat;
  background: url(../../assets/images/blue-sky-background.jpg) no-repeat;
  background-size: 100% 100%;
  position: relative;

  // .logo {
  //   margin-bottom: 40px;
  //   text-align: center;
  // }
  // .logo img {
  //   width: 80%;
  // }

  .footCss {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 15%;
    box-sizing: border-box;
    background: url(../../assets/images/red-footer-background.png) no-repeat;
    background-size: 100% 100%;
  }


  .loginConbox {
    margin: 0 auto;

    .logo {
      font-family: AdobeHeitiStd-Regular;
      font-size: 20px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      /* color: #2361ff; */
    }

    .login-content {
      box-shadow: 0 5px 20px 0 rgba(89,82,82,0.3);
      border-radius: 12px;
      // overflow: hidden;
      width: 380px;
      max-height: 260px;
      position: absolute;
      top:25%;
      left: 38%;
      transform: translate(-50%,-50%);
      background-color: #fff;
      border-radius: 4px;
      box-sizing: border-box;
      padding: 15px 20px 15px;
      transition: all .1s linear;
      opacity: 0.9;
    }

    .logo-left {
      // flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      width: 100%;

      .login-logo {
        margin-top: 50px;
        text-align: center;

        img{
          width: 65%;
        }
      }

      .logo-content {
        position: absolute;
        left: 25px;
        bottom: 27px;

        .top {
          margin: 0;
          font-family: FZLTHK--GBK1-0;
          font-size: 26px;
          font-weight: bold;
          font-stretch: normal;
          // line-height: 1px;
          letter-spacing: 0px;
          color: #f7f9ff;
        }

        .bottom {
          font-family: FZLTHK--GBK1-0;
          font-size: 10px;
          font-weight: normal;
          letter-spacing: 0px;
          color: #f7f9ff;
        }
      }
    }

    .right-content {
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: relative;
      width: 100%;
      background-color: #fff;

      .logo {
        text-align: center;
        
        img {
          width: 80px;
        }
      }

      .title {
        height: 32px;
        width: 40%;
        margin: 10px auto 0;
        box-sizing: border-box;
        background: url(../../assets/images/hansen-logo.png) no-repeat;
        background-size: 100% 100%;
      }

      // .title {
      //   margin-top:10px;
      //   position: relative;
      //   /* font-family: MicrosoftYaHei-Bold; */
      //   font-size: 24px;
      //   text-align: center;
      //   font-weight: 600;
      //   font-stretch: normal;
      //   letter-spacing: 0px;
      //    color: #c7180c; // #70BAFD
      // }


      // .title::after {
      //   content: "";
      //   position: absolute;
      //   left: 0;
      //   bottom: -9px;
      //   width: 40px;
      //   height: 2px;
      //   background-color: #2265fe;
      // }

      .el-form {
        margin-top: 10px;
        text-align: center;

        .el-input__prefix {
          top: 8px !important;

          img {
            width: 18px;
          }
        }

        .el-input__suffix .el-input__icon {
          line-height: 1 !important;
        }

        .el-form-item__content {
          border: none !important;
          line-height: 0 !important;
                    border-bottom:1px solid #e4ebef !important;
          border-radius:0px !important;
        }
        
        .el-form-item {
          margin-bottom: 5px !important;
        }

        .login-subBtn {
          margin-top: 30px;
          height:40px;
          font-size:16px;
          border: none;
          background-color: #c7180c;
          border-radius: 0px 0px 15px 0px;

          span {
            margin-left: 18px;
          }
        }
        
        .operation .el-form-item__content{
          display: flex;
          align-items: center;
          justify-content: space-between;
          border:none !important;
          color:#565e66;

          a{
            font-family: MicrosoftYaHei;
            font-size: 12px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 35px;
            letter-spacing: 0px;
            color: #565e66;
            text-decoration:none;
          }

          a:hover{
            text-decoration:none;
          }
        }
      }

      .el-input,
      button,
      input {
        width: 100%;
        height: 34px;
      }

      .tip {
        position: absolute;
        bottom: 12px;
        width: 100%;
        text-align: center;
        font-family: ArialMT;
        font-size: 9px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #b3cdff;
      }
    }
  }





  .login-subBtn:hover {
    color: #fff !important;
    background-color: rgba(199, 24, 12, 0.7) !important;
  }
  .el-input__inner:focus {
    border-bottom: 1px solid #b40005 !important;
    border-radius:0px;
  }
  .el-input__inner{
    border:none !important;
    font-size:12px !important;
  }
  .el-select {
    width: 100%;
  }

  .loginBox {
    .iconcolor {
      color: #409eff;
    }

    .loginCon {
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      width: 990px;
      margin: auto;

      .el-card__header {
        border-bottom: 0px;
      }
      .title {
        font-size: 30px;
        font-weight: 600;
        color: #ffffff;
        width: 500px;
        margin-top: 0px;
        text-align: center;

        &:first-child {
          font-size: 30px;
          margin-top: 50px;
          // margin-bottom: 30px;
        }
      }

      .login-module {
        width: 380px;
        height: 380px;
        border: none;
        margin-top: 30px;

        .formTitlt {
          font-size: 18px;
          font-weight: 400;

          .titIconbox {
            float: right;

            .pointer {
              cursor: pointer;
            }
          }
        }

        .smalltxt {
          text-align: right;

          .a {
            text-decoration: none;
            color: #999999;
            font-size: 12px;
            margin-left: 8px;
          }
        }
      }

      .el-form-item__content {
        margin-left: 0px !important;

        .subBtn {
          width: 100%;
        }
      }
    }

    .el-input__inner,
    .el-button,
    .el-card,
    .el-message {
      border-radius: 5px !important;
    }

    .el-form-item__content .ico {
      position: absolute;
      top: 0px;
      left: 0px;
      z-index: 999;
      width: 40px;
      height: 39px;
      text-align: center;
      border-right: 1px solid #ccc;
    }

    .ewmbox {
      width: 100%;
      height: 240px;
      margin-top: -25px;

      .ewm {
        width: 140px;
        height: 140px;
        margin: 20px auto;

        p {
          font-size: 12px;
          padding-left: 40px;
          margin: 0;
        }
      }

      .ewmicon {
        width: 140px;
        margin: 20px auto 0;

        .iconfont {
          float: left;
        }

        p {
          font-size: 12px;
          padding-left: 40px;
          margin: 0;
        }
      }
    }
  }

  /* login样式修改 */

  .el-card {
    margin: 120px auto 0;
    padding: 42px 42px 36px;
    border: 1px solid #eaeced;
    overflow: hidden;
  }

  .el-card__body {
    padding: 20px 40px;

    .el-form-item {
      margin-bottom: 20px;
    }

    .el-form-item__content {
      line-height: 35px;
    }

    .el-input__inner {
      border:0px;
      height: 44px;
      line-height: 44px;
    }
  }
}

::v-deep .el-input__inner {
  border: none !important;
  border-bottom: 1px solid #b40005 !important;
}

      
.login-footer{
  position: absolute;
  bottom: 20px;
  left: 40%;
}
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue